import FAQSection from "@/components/feature/FAQSection";

const homeFAQItems = [
  {
    question: `jm下载安全吗？如何确保下载文件的安全性？`,
    answer: `jm下载是安全的，前提是您从官方渠道进行下载。我们建议始终从jm官方网站或官方认证的应用商店（如Microsoft Store、App Store、Google Play等）进行jm下载。下载完成后，可以通过验证文件哈希值、使用杀毒软件扫描等方式进一步确保文件安全。本网站的所有jm下载指南均指向官方渠道，请放心参考。`,
  },
  {
    question: `jm下载最新版在哪里获取？`,
    answer: `jm下载最新版可以通过以下渠道获取：1）访问jm官方网站的下载页面；2）在各大官方应用商店搜索jm；3）通过jm程序内置的自动更新功能升级。我们网站持续追踪jm最新版本动态，在「版本更新」分类中您可以查看最新的版本信息和更新日志。建议始终使用最新版本以获得最佳性能和安全保障。`,
  },
  {
    question: `jm下载失败怎么办？有哪些常见原因？`,
    answer: `jm下载失败通常由以下原因导致：网络不稳定或中断、浏览器缓存问题、防火墙或杀毒软件拦截、服务器临时故障等。建议按以下步骤排查：1）检查网络连接并尝试切换网络；2）清除浏览器缓存后重试；3）暂时禁用防火墙或杀毒软件；4）更换下载工具或在非高峰时段下载。如果问题仍然存在，请查阅我们的「常见问题」分类文章获取更详细的解决方案。`,
  },
  {
    question: `jm下载速度很慢，有什么加速方法？`,
    answer: `jm下载速度慢可以从以下方面优化：1）使用有线网络代替Wi-Fi；2）关闭其他占用带宽的应用程序；3）选择合适的下载时间（避开网络高峰时段）；4）更换DNS服务器为高速公共DNS；5）使用支持多线程的下载工具；6）选择距离较近的下载节点。我们网站有专门的文章详细介绍jm下载加速的十大实用技巧。`,
  },
  {
    question: `jm支持哪些操作系统平台？`,
    answer: `jm支持目前主流的四大操作系统平台：Windows（Windows 10/11 64位）、macOS（macOS 11及以上版本）、Android（Android 8.0及以上版本）和iOS（iOS 14及以上版本）。每个平台都有对应的安装教程，您可以在「安装教程」分类中查看针对您设备系统的详细安装指南。`,
  },
  {
    question: `jm下载后安装需要注意什么？`,
    answer: `jm下载完成后安装时需要注意以下几点：1）Windows用户建议以管理员身份运行安装程序；2）macOS用户首次运行时需在「系统设置」中允许运行；3）Android用户APK安装需开启「允许安装未知来源」选项；4）iOS用户请从App Store直接安装。安装过程中建议保留默认设置，安装后及时检查更新。`,
  },
];

export default function HomeFAQ() {
  return (
    <section className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-8">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            常见问题解答
          </h2>
          <p className="text-foreground-600 text-sm">
            关于jm下载最常见的问题，这里有您需要的答案
          </p>
        </div>
        <FAQSection items={homeFAQItems} />
      </div>
    </section>
  );
}